import { axios as apiService } from '../axiosService';
import { BASE_URL } from './index';

export const getProjectStatus = async (projectId) => {
  if (!projectId || projectId === 'null') {
    return null;
  }
  const res = await apiService.get(
    `${BASE_URL}/project/projectStatus/${projectId}`,
  );
  return res;
};

// pwc user 传guid
// {
//   "guid":"bzhang298"
// }
// client user传 email
// {
//   "email":"905577451@qq.com"
// }
export const accessRecord = async (projectId, data) => {
  if (!projectId || projectId === 'null') {
    return null;
  }
  const res = await apiService.post(
    `${BASE_URL}/project/accessinfo/${projectId}`,
    data,
  );
  return res;
};

export const getComplexityBoardData = async (projectId) => {
  if (!projectId || projectId === 'null') {
    return null;
  }
  const res = await apiService.get(
    `${BASE_URL}/project/dealComplexity/getQuesStatusAndSectionLevel/${projectId}`,
  );
  return res;
};

export const showHideComplexityCompany = async (projectId, data) => {
  const res = await apiService.post(
    `${BASE_URL}/project/projectStatus/${projectId}`,
    data,
  );
  return res;
};

export const dealComplexityCollapseSwitch = async (projectId, data) => {
  const res = await apiService.post(
    `${BASE_URL}/project/projectStatus/${projectId}`,
    data,
  );
  return res;
};
